import { ReactNode } from 'react'
import { YStack, View, Image } from 'tamagui'
import HerosparkLogoSvg from '@assets/hero/herospark-logo.svg'
import { ISchool } from '@dtos/Theme'

interface IGuestCardProps {
  school?: ISchool | null
  children: ReactNode
}

// Cartão central usado pelas telas deslogadas (aceite de convite,
// recuperação de senha) com o logo da escola quando disponível.
export function GuestCard({ school, children }: IGuestCardProps) {
  return (
    <View
      backgroundColor="$bg-page"
      width="100%"
      minHeight="100%"
      paddingVertical={102}
      paddingHorizontal="$size.spacing-xs"
      alignItems="center"
      flex={1}
    >
      <YStack
        width="100%"
        maxWidth={390}
        alignItems="center"
        padding="$size.spacing-md"
        borderRadius="$border-radius-md"
        backgroundColor="$bg-surface"
        gap="$size.spacing-md"
        $gtSm={{ padding: '$size.spacing-lg' }}
      >
        {school?.logo ? (
          <Image
            source={{ uri: school.logo }}
            alt={school.name}
            width={220}
            height={71}
            resizeMode="contain"
          />
        ) : (
          <HerosparkLogoSvg height={43} width={220} />
        )}

        {children}
      </YStack>
    </View>
  )
}
